import { JSBI, ZERO } from '@sushiswap/core-sdk';

function toAmount(rebase, shares, roundUp) {
  if (roundUp === void 0) {
    roundUp = false;
  }

  if (JSBI.EQ(rebase.base, ZERO)) return shares;
  var elastic = JSBI.divide(JSBI.multiply(shares, rebase.elastic), rebase.base);

  if (roundUp && JSBI.LT(JSBI.divide(JSBI.multiply(elastic, rebase.base), rebase.elastic), shares)) {
    return JSBI.add(elastic, JSBI.BigInt(1));
  }

  return elastic;
}
function toShare(rebase, amount, roundUp) {
  if (roundUp === void 0) {
    roundUp = false;
  }

  if (JSBI.EQ(rebase.elastic, ZERO)) return amount;
  var base = JSBI.divide(JSBI.multiply(amount, rebase.base), rebase.elastic);

  if (roundUp && JSBI.LT(JSBI.divide(JSBI.multiply(base, rebase.elastic), rebase.base), amount)) {
    return JSBI.add(base, JSBI.BigInt(1));
  }

  return base;
}

export { toAmount, toShare };
//# sourceMappingURL=bentobox-sdk.esm.js.map
